<form [formGroup]="form" *appLoader="!form">
  <app-dialog-container
    title="{{ 'addToStock' | translate }}"
    [isValid]="form.valid"
    (confirmButtonHandler)="save()"
  >
    <div class="row-container">
      <app-ui-input
        label="{{ 'currentStock' | translate }}"
        [control]="form.currentStock"
        type="number"
      ></app-ui-input>
      <app-ui-input
        label="{{ 'addedStock' | translate }}"
        [control]="form.amount"
        [required]="true"
        type="number"
        min="0"
      ></app-ui-input>
      <app-ui-input
        label="{{ 'newStock' | translate }}"
        [control]="form.newStock"
        type="number"
      ></app-ui-input>
    </div>
    <app-ui-text-area
      [label]="'description' | translate"
      [control]="form.reason"
      [required]="true"
    ></app-ui-text-area>
  </app-dialog-container>
</form>
